<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3016 5.83337C19.4766 5.83337 20.5342 6.3034 21.2392 7.12594C22.1793 6.89093 23.1193 6.65592 23.9419 6.06839C23.5893 7.00843 23.0018 7.83098 22.0618 8.301C23.0018 8.18349 23.7068 7.94848 24.4119 7.71347C23.8244 8.53601 23.1193 9.24105 22.4143 9.82858C22.4143 9.94608 22.4143 10.1811 22.4143 10.2986C22.4143 15.8214 18.1841 22.1667 10.5462 22.1667C8.19605 22.1667 5.96344 21.4617 4.08334 20.2866C4.43586 20.4041 4.78838 20.4041 5.1409 20.4041C7.1385 20.4041 8.90109 19.8166 10.3112 18.6415C8.54857 18.524 6.90349 17.349 6.43346 15.7039C6.66848 15.8214 6.90349 15.8214 7.1385 15.8214C7.49102 15.8214 7.84354 15.7039 8.19605 15.7039C6.43346 15.3514 5.02339 13.7063 5.02339 11.7087C5.61092 12.0612 6.19845 12.1787 6.90349 12.1787C5.84593 11.4737 5.02339 10.1811 5.02339 8.65352C5.02339 7.94848 5.2584 7.24345 5.61092 6.53841C7.72603 9.12354 10.7812 10.7686 14.1889 10.8861C14.1889 10.6511 14.1889 10.2986 14.1889 10.0636C14.1889 7.71347 16.069 5.83337 18.3016 5.83337Z"
      :stroke="color"
      :fill="filled ? color : 'transparent'"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
